
import { JsonServiceClient } from "@servicestack/client";

export const DefaultClient = (baseUrl?: string, basePath?: string) => {
    const client = new JsonServiceClient(baseUrl)
    .apply(c => {
        c.basePath = basePath ?? null;
        c.headers = new Headers(); //avoid pre-flight CORS requests
    });

    client.exceptionFilter = (res: Response) => {
        res;
        // TODO: Handle errors
    };

    return client;
}

export default DefaultClient;